export default __webpack_public_path__ + "static/media/ani.f8f7aef6.png";